import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Tab, Tabs, Button, Dropdown } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear, faMoneyBillTransfer, faReceipt } from '@fortawesome/free-solid-svg-icons';

import Cargoplane from "../../../../assets/images/plane.svg";
import Arcv from "../../../../assets/images/archive.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";

import { Link } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import Rapdf from "../../../../assets/images/pdf.png";
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { ULDONLOANGRID, MVTONLOAN, FINALIZETR, GETULDDETAILS, MVTHDETAILS, EDITPTRANSFER, MOVETOACTARC } from '../../../../Utils/conts.js';
import DownloadGrid from '../components/DownloadGrid.js';
import ConfModal from '../../../../Components/common/ConfModal.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const Onloan = ({ linkClick }) => {
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [totalLoan, setTotalLoan] = useState({});
    const [totalPending, setTotalPending] = useState({});
    const [gridData, setGridData] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [activeTab, setActiveTab] = useState('Loan');
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});

    const fetchDataGridL = async () => {
        const tabName = activeTab == 'Loan' ? 'L' : 'T';
        setIsLoading(true);
        try {
            const res = await withRFSToken.post(ULDONLOANGRID, { type: tabName })
                .then(function (res) {
                    const innerData = res.data.response_data.loan_data;
                    setIsLoading(false);
                    if (activeTab == 'Loan') {
                        setGridData({ Loan: innerData });
                    } else {
                        setGridData({ Transfer: innerData });
                    }

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // const fetchDataGridT = async () => {
    //     try {
    //         const res = await withRFSToken.post(ULDONLOANGRID, { type: 'T' })
    //             .then(function (res) {
    //                 const innerData = res.data.response_data.loan_data;
    //                 console.log('inn', innerData);
    //                 setGridData({ Transfer: innerData });
    //             });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGridL();
        setIsLoading(false);
        setGridData({});
        // fetchDataGridT();
        isMounted.current = true;
    }, [])
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);

    const [isFinalize, setIsFinalize] = useState(false);
    const [action, setAction] = useState();
    const [finalizeData, setFinalizeData] = useState('');
    const gridRef = useRef(null);
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setIsLoading(true);
        setFilterApplied(false);
        setSelectedRowData();
        if (tab == 'Loan') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Loan: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Transfer: {} });
            }, 1);
        }


    };
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {

        if (gridRef.current) {
            // if (gridData[activeTab]) {

            const pageSize = 20;
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Loan') { tabType = 'L' } else { tabType = 'T' }
            const source = {

                datatype: 'json',

                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_id', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'condition', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'agent_name', type: 'string' },
                    { name: 'transfer_date', type: 'string' },
                    { name: 'days', type: 'string' },
                    { name: 'control_receipt_number', type: 'string' },

                ],
                id: `${activeTab}`,
                url: `${process.env.REACT_APP_RFS_URL}handler-uld/list?tab=on_loan&type=A`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },

                pagesize: 50,
                filter: function (allfilters) {
                    // window.$(gridRef.current).jqxGrid('clearselection');
                    // setGridSelect([]);

                    // if (allfilters.length > 0) {
                    //     console.log("Filter Applied");
                    //     setFilterApplied(true);
                    // } else {
                    //     console.log("Filter Cleared");
                    //     setFilterApplied(false);
                    // }
                    // window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRef.current).jqxGrid('getrows');

                    //     console.log("rows",rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);                            
                    //         rows.forEach((element,index) => {
                    //             if(element.uld_number==uldNumber){
                    //                 window.$(gridRef.current).jqxGrid('selectrow', index);
                    //             }
                    //         });                            
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    let loanCount = 0;
                    let pendingCount = 0;
                    if (data) {
                        loanCount = data.lcount;
                        pendingCount = data.ocount;
                    }
                    setTotalLoan({ totalUlds: loanCount });
                    setTotalPending({ totalUlds: pendingCount });
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // console.log('localdata', source.localdata)
            const columns = [
                // {
                //     text: 'Actions',
                //     cellsrenderer: function () {
                //         return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                //     },
                //     width: '4%', filterable: false,
                // },
                { text: 'ULD No.', filtertype: 'textbox', datafield: 'uld_number', width: '11%', cellclassname: '', },
                { text: 'Type Code', filtertype: 'textbox', datafield: 'type_code', width: '6%', cellclassname: '', },
                { text: 'Serial Number', filtertype: 'textbox', datafield: 'serial_number', width: '10%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '6%', cellclassname: '', },
                {
                    text: 'Condition Code', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Serviceable', value: 'SER' },
                        { label: 'Damaged', value: 'DAM' },
                        { label: 'Discarded', value: 'DIS' }
                    ], datafield: 'condition', width: '8%', cellclassname: '',
                },
                { text: 'Agent', filtertype: 'textbox', datafield: 'agent_name', width: '8%', cellclassname: '', },
                { text: 'Transfer Date', filtertype: 'textbox', datafield: 'transfer_date', width: '8%', cellclassname: '', },

                {
                    text: 'Day(s) On Loan', filtertype: 'textbox',
                    cellclassname: (row, column, value) => {
                        // Extract the number of days from the on_loan string
                        const daysMatch = isNaN(value) ?? value.match(/(\d+)\s*day\(s\)/);
                        if (daysMatch) {
                            const days = parseInt(daysMatch[1], 10);
                            if (days === 0) {
                                return ''; // No class if the value is 0
                            } else if (days >= 10) {
                                return 'lucinred';
                            } else if (days >= 7) {
                                return 'lucinorange';
                            }
                        }
                        return ''; // Default class if format is unexpected
                    },
                    datafield: 'days', width: '10%',
                },

                // { text: 'Station Agent', filtertype: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'luc_out', width: '10%', cellclassname: '', },
                // { text: 'Station Agent', filtertype: 'textbox', datafield: 'station_agent', width: '10%', cellclassname: '', },
                //  { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '6%', cellclassname: '', },
                // {
                //     text: 'Control Receipt No.', filtertype: 'checkedlist',
                //     filteritems: [
                //         { label: 'Owned', value: 'Y' },
                //         { label: 'Lease', value: 'N' },
                //     ],
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         if (rowdata.asset_type === 'Y') {
                //             return '<div class="jqx-grid-cell-left-align set_dock ">Owned</div>';
                //         } else {
                //             return '<div class="jqx-grid-cell-left-align set_dock ">Lease</div>';
                //         }
                //     },
                //     datafield: 'asset_type', width: '8%', cellclassname: '',
                // },
                { text: 'Control Receipt No.', filtertype: 'textbox', datafield: 'control_receipt_number', width: '8%', cellclassname: '', },
                // {
                //     text: 'Pending Transfer', filtertype: 'checkedlist',
                //     filteritems: [
                //         { label: 'Yes', value: 'yes' },
                //         { label: 'No', value: 'no' },
                //     ], datafield: 'pending_transfer', width: '8%', cellclassname: '',
                // },
                // { text: 'UCR No.', filtertype: 'textbox', datafield: 'control_receipt_no', width: '8%', cellclassname: '', },
                // { text: 'Transfer Point', filtertype: 'textbox', datafield: 'transfer_point', width: '8%', cellclassname: '', },
                // { text: 'Transferred By', filtertype: 'textbox', datafield: 'transferred_by_name', width: '8%', cellclassname: '', },

                // { text: 'Warehouse Name', filtertype: 'textbox', datafield: 'awb_number', width: '9%', cellclassname: '', },
            ];
            // Nested Start
            const nestedColumns = [
                { text: 'ULD Number', datafield: 'uld_number', width: '8%' },
                { text: 'Type Code', datafield: 'type_code', width: '8%' },
                { text: 'Serial Number', datafield: 'serial_number', width: '8%' },
                { text: 'Owner Code', datafield: 'owner_code', width: '8%' },

                // Add more columns as needed
            ];
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // console.log('Nested arrow clicked:', record);
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });
                console.log('data', dataAdapter);
                const id = record.uid.toString();
                const uldGrid = dataAdapter.loadedData.Rows[id].uldInfo;

                const nestedSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'uld_number', type: 'string' },
                        { name: 'type_code', type: 'string' },
                        { name: 'serial_number', type: 'string' },
                        { name: 'owner_code', type: 'string' },
                        { name: 'pending_transfer_id', type: 'string' },
                        { name: 'uld_id', type: 'string' },
                    ],
                    localdata: uldGrid,
                }
                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: (10 * 45),
                    // selectionmode: 'checkbox',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };
            // Nested End

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: activeTab === 'Loan' ? 'checkbox' : 'none',
                pageable: true,
                initrowdetails: activeTab === 'Transfer' ? initrowdetails : '',
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                // pagerrenderer: pagerRenderer,
                rendergridrows: function (params) {
                    return params.data;
                },
                rowdetails: activeTab === 'Transfer' ? true : false,
                rowdetailstemplate: activeTab === 'Transfer' ? {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (15 * 45),
                    rowdetailshidden: true,
                } : '',

                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }

            };

            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            // window.$(gridRef?.current).on('bindingcomplete', function () {
            //     window.$(gridRef?.current).jqxGrid({ pagesizeoptions: ['20', '50', '100', '200', '500'] });
            // });

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            // row selection by checkbox
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                // console.log("🚀 ~ window.$ ~ event:1111", event.args.row)
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    console.log("🚀 ~ window.$ ~ unselectedRowId:", unselectedRowId)
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));

                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            // End row selection 
            window.$(gridRef.current).on('click', '.finalize', function () {
                // console.log("🚀 ~ event:01010", event)
                const rowDiv = window.$(this).closest('[role="row"]');
                // console.log("🚀 ~ cellDiv:", rowDiv)
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        setFinalizeData(rowData.batch_no);
                        // setIsFinalize(true);
                        handleModalOpen('F');
                        // setEditData(dataToSend);
                        // setShowEdit(true);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);



            });
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const keysToRemove = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
                keysToRemove.forEach(key => {
                    localStorage.removeItem(key);
                });
                // console.log("🚀 ~ event:01010", event)
                const rowDiv = window.$(this).closest('[role="row"]');
                // const cellDiv = this.id;
                // console.log("🚀 ~ cellDiv:", rowDiv)
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                if (activeTab == 'Loan') {
                    const storageData = {
                        "ULD": [
                            {

                            }
                        ],  // ULD Details section
                        "Form": {},  // Empty form section
                        "Edit": 'onloan'
                    };
                    localStorage.setItem('LUC Out', JSON.stringify(storageData));
                    localStorage.setItem('HULDtab', 'onloan');
                    const fnPageUrl = '/ULDControl/ULDFunction';  // ${itemId} Change "/details/" to the actual path of your details page
                    // Navigate to the details page
                    window.location.href = fnPageUrl;
                } else {
                    onLoanEdit(rowData.batch_no);
                }
            });


        }
        window.$(gridRef.current).off('cellclick');

        window.$(gridRef.current).on('cellclick', (event) => {
            const args = event.args.row.bounddata;
            if (event.args.columnindex > 0) {
                // For Remove Checkbox Selection
                if (gridSelect) {
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    // setGridSelect([]);
                }
                // For Remove Checkbox Selection
                loadDetails(args.uld_number);
            }
        });
    }, [gridData]);

    const handleModalOpen = (pos) => {
        setAction(pos);
        setIsFinalize(true);
    };

    const onLoanEdit = async (batch) => {
        try {
            const res = await withRFSToken.post(EDITPTRANSFER, { batch_no: batch })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ innerData:", innerData)

                    const storageData = {
                        "ULD": innerData.ULD,  // ULD Details section
                        "Form": innerData.Form,  // Empty form section
                        "Edit": innerData.go_to
                    };
                    localStorage.setItem(innerData.go_to, JSON.stringify(storageData));
                    localStorage.setItem('HULDtab', 'onloan');
                    const fnPageUrl = '/ULDControl/ULDFunction';  // ${itemId} Change "/details/" to the actual path of your details page
                    // Navigate to the details page
                    window.location.href = fnPageUrl;
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const loadDetails = async (uldNumber) => {
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setSelectedRowData(innerData);
                    setTimeout(() => {
                        window.$(gridRef.current).jqxGrid('refresh');
                    }, 30);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRef.current).jqxGrid('refresh');
        }, 30);
    };

    const confirmModal = () => {
        if (action === 'F') {
            confirmFinalize();
        } else {
            moveToArchive();
        }
    }
    const confirmFinalize = async () => {
        // console.log('101', gridSelect);
        // const sendAction = activeTab == 'Active' ? 'R' : 'A';
        // const uldNumbers = gridSelect && gridSelect.map(num => num.uld_number)
        try {
            const res = await withRFSToken.post(FINALIZETR, { batch_no: finalizeData })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success('Finalized Success');
                        setFinalizeData('');
                        setIsFinalize(false);
                        fetchDataGridL();
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);
    };

    // +++++++++++++++++++ div +++++++++++++++++++++++++

    // upload Section
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }
    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result });

                if (filesWithBase64.length === selectedFiles.length) {
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };

    const movementHistoryClick = () => {
        localStorage.removeItem('MHistory');
        const storageData = {
            ULD: selectedRowData,  // ULD Details section
            Form: {}  // Empty form section
        };
        localStorage.setItem('MHistory', JSON.stringify(storageData));
        // localStorage.setItem('tab', 'operations');
        window.location.href = '/ULDControl/MovementHistory'
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // History Details
    const handleDetailsClick = async (history) => {
        console.log("🚀 ~ handleDetailsClick ~ history:", history)

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }

        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id, group_id: history.group_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    // +++++++++++++++++++++++++++++++++++++++++++++++++++++ file upload 

    const handleDropdownItemClick = async (pos, action) => {
        const keysToRemove = [
            'Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out',
            'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'
        ];

        // Remove keys from localStorage
        keysToRemove.forEach(key => localStorage.removeItem(key));

        // Helper function to save data and navigate to the given URL
        const saveAndNavigate = (action, data) => {
            localStorage.setItem(action, JSON.stringify(data));
            localStorage.setItem('HULDtab', 'onloan');
            // window.location.href = url;
            linkClick('UF')
        };

        // Helper function to create storage data for ULD
        const createStorageData = (ULDData, additionalForm = {}) => {
            // const form = {
            //     flight_or_truck: ULDData.flight_or_truck === 'Flight' ? 'F' : 'T',
            //     flight_number: ULDData.flight_number,
            //     flight_date: ULDData.flight_date,
            //     origin: ULDData.origin,
            //     destination: ULDData.destination,
            //     ...additionalForm
            // };
            return { ULD: [ULDData], Form: additionalForm };
        };

        const handleDetails = async () => {
            const storageData = { ULD: [selectedRowData], Form: {} };
            saveAndNavigate(action, storageData);
        };

        // Handle operations for 'top' position
        const handleTop = async () => {
            if (gridSelect.length === 0) {
                if (['LUC In', 'Transfer', 'Request', 'Lease Out', 'LUC In'].includes(action)) {
                    const storageData = { ULD: [], Form: {} };
                    saveAndNavigate(action, storageData);
                }
            } else {
                // if (action !== 'LUC In') {
                if (['LUC In'].includes(action)) {
                    const chkHnd = gridSelect.every(hd => hd.agent_name === gridSelect[0].agent_name);
                    const storageData = { ULD: gridSelect, Form: {} };
                    if (chkHnd) {
                        saveAndNavigate(action, storageData);
                    } else {
                        setModalConf(true)
                        setConfData({
                            header: 'Different agent name found',
                            subHeader: `ULD's selected with different agents. Are you sure you want to continue?`,
                            modalConf: () => functionNavigate(action, storageData),
                            closeModal: () => setModalConf(false),
                            primaryBtn: 'Yes',
                            secondaryBtn: 'No',
                        })
                    }
                } else if (['Transfer', 'Request'].includes(action)) {
                    const actionType = action == 'Transfer' ? 'ST' : (action == 'Request' ? 'TR' : 'LI')
                    console.log("🚀 ~ handleTop ~ actionType:", actionType)
                    try {
                        const response = await withRFSToken.post(MVTONLOAN, { action_type: actionType, ulds: gridSelect.map(item => item.uld_number) });
                        const innerData = response.data;
                        const { response_code, response_data } = response.data;
                        if (response_code === 200) {
                            // if (response_data.logic_type === 1) {
                            const storageData = {
                                ULD: response_data.uldInfo,
                                Form: response_data.Form
                            };
                            saveAndNavigate(action, storageData);
                            // } else {
                            //     setResponseAction(response_data);
                            //     setShowConfirmation(true);
                            // }
                        }
                        else { toast.error(response.data.response_msg) }
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                } else if (action === 'Lease Out') {
                    const hasOwnedAssetType = gridSelect.some(item => item.asset_type === 'Y');
                    if (hasOwnedAssetType) {
                        toast.error("ULDs with asset type Owned selected, this action is not possible.");
                    } else {
                        const storageData = { ULD: gridSelect, Form: {} };
                        saveAndNavigate(action, storageData);
                    }
                } else {
                    const storageData = { ULD: gridSelect, Form: {} };
                    saveAndNavigate(action, storageData);
                }

            }
        };

        // Main conditional logic based on position
        if (pos === 'details') {
            await handleDetails();
        } else if (pos === 'top') {
            await handleTop();
        }
    };
    const resetFilters = () => {
        window.$(gridRef.current).jqxGrid('clearfilters');
    };


    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            handleModalOpen('A');
            // setActArcModal(true);
        }
    };

    const functionNavigate = (action, data) => {
        localStorage.setItem(action, JSON.stringify(data));
        localStorage.setItem('HULDtab', 'onloan');
        // window.location.href = url;
        linkClick('UF')
    };

    const [actArcModal, setActArcModal] = useState(false);
    const moveToArchive = async () => {

        const ids = gridSelect.map(uld => uld.uld_id);
        console.log("line=>907", ids);

        try {
            const res = await withRFSToken.post(MOVETOACTARC, { uld_numbers: ids, action: "R" })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });

                        setIsLoading(true);
                        if (activeTab == 'Loan') {
                            setTimeout(() => {
                                setIsLoading(false);
                                setGridData({ Loan: {} });
                            }, 1);
                        } else {
                            setTimeout(() => {
                                setIsLoading(false);
                                setGridData({ Transfer: {} });
                            }, 1);
                        }
                        setIsFinalize(false);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }

    const sendDload = { sec: 'uld', tab: 'on_loan' }

    return (
        <>
            {/* {console.log('gridSelect', gridSelect)} */}
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={confData.closeModal}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            {downloadOpen && <DownloadGrid download_sec={sendDload} onClose={closeDownloadModal} />}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    {/* <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                            <FontAwesomeIcon icon={faPlus} /> Add ULD <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                            <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC In')}>LUC In</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {/* <button className="transfer" variant="link" onClick={() => handleDropdownItemClick('top', 'Transfer')}>
                        <span> <FontAwesomeIcon icon={faMoneyBillTransfer} /> Station Transfer</span>
                    </button>
                    <button className="receive" variant="link" onClick={() => handleDropdownItemClick('top', 'Request')}>
                        <span> <FontAwesomeIcon icon={faReceipt} /> Transfer Request</span>
                    </button> */}
                    {/* <span className="selected">
                        Selected ULD <Badge>{gridSelect.length}</Badge>
                    </span> */}
                </div>
            </div>

            <div className='ulddown'>
                {/* <button onClick={handleMoveToActArc}><img src={Arcv} /> Archive</button> */}
                <button onClick={showDownloadModal}><img src={Export} /> Download</button>
            </div>

            <div className="maindiv">
                <div className='trashdonload'>
                    {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_number} &nbsp; <span>{selectedRowData.status}</span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'LUC In')}>LUC In</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        {/* <div className='d-flex justify-content-between rabord'>
                            <div className='firstbrd'>
                                <p>Origin</p>
                                <span>{selectedRowData.origin}</span>
                            </div>
                            <div className='middlebrd'>
                                <p>{selectedRowData.flight_date}</p>
                                <p><img src={Cargoplane} /></p>
                                <p>{selectedRowData.flight_number}</p>
                            </div>
                            <div className='lastbrd'>
                                <p>Destination</p>
                                <span>{selectedRowData.destination}</span>
                            </div>
                        </div> */}
                        <div className='movment_history'>
                            <h3>Movement History</h3> <Link to='#' onClick={movementHistoryClick}>View All</Link>
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => (
                                    <li key={index}>
                                        <span className='movem'>{history.operation_type}</span>
                                        <span className='mvdate'>{history.operation_date}</span>
                                        <Link to='#' onClick={() => handleDetailsClick(history)}>Details</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* {selectedRowData && selectedRowData.operational_trucks.map((truck) => (
                                <div key={truck.truck_id} className='d-flex justify-content-between align-items-center opt_truck'>
                                    {console.log("🚀 ~ ExportActive ~ truck:", truck)}
                                    <div>
                                        <span>Truck No</span>
                                        <h4>{truck.truck_no}</h4>
                                    </div>
                                    <div className={truck.request_status == 'O' ? 'offer_reecv' : (truck.request_status == 'B' ? 'booked' : 'offer_rqst')}>
                                        <span>{truck.request_status == 'O' ? 'Offer Received' : (truck.request_status == 'B' ? 'Booked' : 'Requested')}</span>
                                    </div>
                                    <div>
                                        <Link>Details</Link>
                                    </div>
                                </div>
                            ))} */}
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"handler_ulds"}
                            attachable_id={selectedRowData.id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.id)}
                        />
                        <ActivityComments
                            commentable_type={"handler_ulds"}
                            commentable_id={selectedRowData.id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={loadDetails}
                        />
                    </div>
                )}

                <Modal show={isFinalize} onHide={() => setIsFinalize(false)} className='addfrom change_type' centered>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        {action === 'F' ?
                            <>
                                <h3>Finalize Pending Transfer</h3>
                                <p>Are you sure you want to Finalize?</p>
                            </>
                            :
                            <>
                                <h3>Selected {gridSelect.length > 1 ? "ULD's" : 'ULD'} will move to Archive </h3>
                                <p>Are you sure you want to move {gridSelect.length > 1 ? "ULD's" : 'ULD'} to Archive ?</p>
                            </>
                        }

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex w-50 mx-auto are_bottom'>
                            <Button variant="secondary" onClick={() => setIsFinalize(false)}>
                                No
                            </Button>
                            <Button variant="primary" onClick={confirmModal}>
                                Yes
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    )
}

export default Onloan